import {Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import MDInput from "../../../materialDashboard/components/MDInput";
import SeasonSelect from "../SeasonSelect";

export const useToolbar = ({initialSelectedAttribute, availableAttributes, availableSeasons}) => {
    const sortedSeason = availableSeasons.sort((a, b) => b - a);

    const [selectedAttribute, setSelectedAttribute] = useState(initialSelectedAttribute);
    const [seasonFrom, setSeasonFrom] = useState(sortedSeason?.[sortedSeason.length - 1] ?? null)
    const [seasonTo, setSeasonTo] = useState(null);

    console.log(sortedSeason, seasonFrom, sortedSeason?.[sortedSeason.length - 1]);

    useEffect(() => {
        setSeasonFrom(sortedSeason?.[sortedSeason.length - 1] ?? null);
        setSeasonTo(null);
    }, [availableSeasons]);

    return {
        selectedAttribute,
        setSelectedAttribute,
        availableAttributes,
        seasonFrom,
        setSeasonFrom,
        seasonTo,
        setSeasonTo,
        availableSeasons,
    }
}

const Toolbar = (props) => {
    const {t} = useTranslation("graphs");
    const {
        selectedAttribute,
        setSelectedAttribute,
        availableAttributes,
        seasonFrom,
        setSeasonFrom,
        seasonTo,
        setSeasonTo,
        availableSeasons,
    } = props;

    const handleAttributeChange = (event) => {
        const value = event.target.value;
        setSelectedAttribute(value);
    }

    return <Grid container sx={{py: 4}} columnSpacing={2}>
        <Grid item xs={12} lg={3}>
            <MDInput label={t("toolbar.attributeLabel")}
                     value={selectedAttribute ?? ""}
                     onChange={handleAttributeChange}
                     variant="standard"
                     select
                     fullWidth>
                {
                    availableAttributes.map(attribute => (
                        <MenuItem key={attribute.label} value={attribute.value}>{attribute.label}</MenuItem>
                    ))
                }
            </MDInput>
        </Grid>
        <Grid item xs={12} lg={3}>
            <SeasonSelect selectedSeason={seasonFrom}
                          setSelectedSeason={setSeasonFrom}
                          sx={{minWidth: "9rem"}}
                          label={t("toolbar.seasonFrom")}
                          availableSeasons={availableSeasons}
                          fullWidth
            />
        </Grid>
        <Grid item xs={12} lg={3}>
            <SeasonSelect selectedSeason={seasonTo}
                          setSelectedSeason={setSeasonTo}
                          sx={{minWidth: "9rem"}}
                          label={t("toolbar.seasonTo")}
                          availableSeasons={availableSeasons}
                          optionsFrom={seasonFrom}
                          fullWidth
            />
        </Grid>
    </Grid>
}

export default Toolbar;
